import React from 'react';

interface ScoreStatusProps {
  score: number;
}

const getStatusDetails = (score: number) => {
  if (score >= 85) {
    return { color: 'bg-green-500' };
  } else if (score >= 70) {
    return { color: 'bg-blue-500' };
  } else if (score >= 50) {
    return { color: 'bg-yellow-500' };
  } else {
    return { color: 'bg-red-500' };
  }
};

const ScoreStatus: React.FC<ScoreStatusProps> = ({ score }) => {
  const { color } = getStatusDetails(score);

  return (
    <div className='flex items-center gap-2'>
      <span className={`w-3 h-3 rounded-full ${color}`} />
      <span className='text-gray-800 font-medium'>{ score }%</span>
    </div>
  );
};

export default ScoreStatus;
